import './OpSearchbox.scss'

import React from 'react'
import Fuse from 'fuse.js'

import OpTextbox from 'common/views/components/OpTextbox'
import SearchItem from './SearchItem'

class OpSearchbox extends React.Component {
  constructor(props) {
    super(props)

    const { searchKeys, searchOptions = {}, searchSource = [] } = props

    this.defaultFuseOptions = {
      shouldSort: true,
      threshold: 0.7,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 2,
      tokenize: true,
      includeMatches: false,
      keys: searchKeys
    }

    this.searchSource = searchSource
    this.fuseOptions = Object.assign({}, this.defaultFuseOptions, searchOptions)
    this.fuse = new Fuse(this.searchSource, this.fuseOptions)
  }

  state = {
    items: [],
    selectedIndex: 0
  }

  _selectIndex = (selectedIndex) => {
    this.props.onChangeHighlighted(this.state.items[selectedIndex])
    this.setState({ selectedIndex })
  }

  _moveUp = () => {
    if (this.state.selectedIndex > 0) {
      this._selectIndex(this.state.selectedIndex - 1)
      return
    }

    if (!this.props.cycleToTop) {
      return
    }

    this._selectIndex(this.state.items.length - 1)
  }

  _moveDown() {
    const itemsLength = this.state.items.length - 1

    if (this.state.selectedIndex < itemsLength) {
      this._selectIndex(this.state.selectedIndex + 1)
      return
    }

    if (!this.props.cycleToTop) {
      return
    }

    this._selectIndex(0)
  }

  _onKeyDown = (event) => {
    switch (event.key) {
      case "ArrowUp":
        this._moveUp()
        event.preventDefault()
        break

      case "ArrowDown":
        this._moveDown()
        event.preventDefault()
        break

      case "Tab":
        if (event.shiftKey) {
          this._moveUp()
        } else {
          this._moveDown()
        }
        event.preventDefault()
        break;

      case "Enter":
      {
        const item = this.state.items[this.state.selectedIndex]
        if (!item) {
          return
        }
        this.setState({ items: [] })
        this.props.onSelectResult(item)
        break
      }

      case "Escape":
        this.setState({ items: [] })
        this.props.onClose()
    }
  }

  _onInputChange = (event) => {
    const value = event.target.value

    if (value.length) {
      const items = this.fuse.search(value)
      this.setState({
        items: items.slice(0, this.props.maxDisplay),
        selectedIndex: 0
      })
      return
    }

    this.setState({ items: [], selectedIndex: 0 })
  }

  componentDidUpdate(prevProps) {
    const { searchSource, searchOptions, searchKeys } = this.props
    if (searchSource !== prevProps.searchSource || searchOptions !== prevProps.searchOptions || searchKeys !== prevProps.searchKeys) {
      this.searchSource = searchSource
      this.fuseOptions = Object.assign({}, this.defaultFuseOptions, searchOptions, { keys: searchKeys })
      this.fuse = new Fuse(this.searchSource, this.fuseOptions)
    }
  }

  render() {
    const props = this.props

    const { placeholder, iconClass, onSelectResult, renderItem } = props
    const { items } = this.state

    return (
      <div className="OpSearchbox" onBlur={() => {
        this.setState({ items: [] })
      }}>
        <OpTextbox
          {...props}
          className="OpSearchbox--input"
          onKeyDown={this._onKeyDown}
          onChange={this._onInputChange}
          iconClass={iconClass || "fa fa-search search-box-icon"}
          placeholder={placeholder || "Search"}
        />
        <div className="OpSearchbox--results" style={{ display: items.length ? 'block' : 'none'}}>
          {_.map(items, (r, idx) =>
            <SearchItem
              key={idx}
              className={`-result ${idx === this.state.selectedIndex && '-selected'}`}
              onMouseEnter={() => {
                this.setState({selectedIndex: idx})
              }}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                onSelectResult(r)
                this.setState({ items: [] })
              }}
            >
              {renderItem(r)}
            </SearchItem>
          )}
        </div>
      </div>
    )
  }
}

OpSearchbox.defaultProps = {
  maxDisplay: 6,
  cycleToTop: true,
  onChangeHighlighted: () => {},
  onSelectResult: () => {},
  onClose: () => {},
  renderItem: (item) => {
    return item
  }
};

export default OpSearchbox
